import * as React from "react"
export const Svg_022 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={58}
    height={58}
    fill="none"
  >
    <g clipPath="url(#a)">
      <path
        fill="url(#b)"
        d="M49.506 8.494C44.03 3.017 36.746 0 29 0S13.971 3.017 8.494 8.494 0 21.254 0 29s3.017 15.029 8.494 20.506S21.254 58 29 58s15.029-3.017 20.506-8.494S58 36.746 58 29s-3.017-15.029-8.494-20.506ZM29 51.204C16.757 51.203 6.797 41.242 6.797 29S16.757 6.797 29 6.797c12.243 0 22.203 9.96 22.203 22.203 0 12.243-9.96 22.203-22.203 22.203Z"
      />
      <path
        fill="url(#c)"
        d="M29 10.195c-10.369 0-18.805 8.436-18.805 18.805S18.631 47.805 29 47.805 47.805 39.369 47.805 29 39.369 10.195 29 10.195ZM18.18 30.7h-3.398v-3.398h3.398v3.398Zm10.171-3.398h1.297a5.18 5.18 0 0 1 5.175 5.174 5.183 5.183 0 0 1-4.124 5.068v2.27h-3.398v-2.201a4.733 4.733 0 0 1-4.124-4.688h3.398a1.33 1.33 0 0 0 1.328 1.327h1.746c.979 0 1.776-.796 1.776-1.776s-.797-1.776-1.776-1.776h-1.297a5.18 5.18 0 0 1-5.175-5.174 5.183 5.183 0 0 1 4.124-5.068v-2.27h3.398v2.201a4.733 4.733 0 0 1 4.124 4.688h-3.398a1.33 1.33 0 0 0-1.328-1.327h-1.746c-.979 0-1.776.796-1.776 1.776s.797 1.776 1.776 1.776Zm11.469 3.398v-3.398h3.398v3.398H39.82Z"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={13.412}
        x2={40.962}
        y1={8.7}
        y2={53.288}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={18.892}
        x2={36.757}
        y1={15.837}
        y2={44.749}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h58v58H0z" />
      </clipPath>
    </defs>
  </svg>
)